import axios from "axios";
import { JSON_URL } from "../../config/RouterLink";

// Constantes
const inicialExcel = {
  privacidad: "",
  cargando: false,
  message: "",
};

const API_URL_DESCARGA_PRIVACIDAD =
  "/ConcursoPublico/api/reportes/descargar_privacidad";
// Types

const GET_PRIVACIDAD = "GET_PRIVACIDAD";
//------------------------------------------------

const GET_DESCARGA_PRIVACIDAD_ERROR = "GET_DESCARGA_PRIVACIDAD_ERROR";

// Reducer
export default function descargaPrivacidadReducer(
  state = inicialExcel,
  action
) {
  switch (action.type) {
    case GET_PRIVACIDAD:
      return {
        ...state,
        privacidad: action.payload,
        cargando: false,
      };

    default:
      return state;
  }
}

export const descargaPrivacidad = (data) => async (dispatch, getState) => {
  //let data = JSON.stringify({});

  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const response = await axios({
      url: urls.data.urlServer + API_URL_DESCARGA_PRIVACIDAD,
      method: "POST",
      data,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/pdf",
      },
    })
      //const response = await axios.post(urls.data.urlServer + API_URL_DESCARGA_PRIVACIDAD ,  data )
      .then((response) => {
        //console.log(response.data);
        //var printWindow = window.open(response.data);
        //printWindow.print();
        //window.close();

        const w = window.open(response.data, "_blank");
        w && w.focus();
      });

    dispatch({
      type: GET_PRIVACIDAD,
      payload: JSON.parse(JSON.stringify(response.data)),
    });
  } catch (error) {
    if (error.response) {
      // client received an error response (5xx, 4xx)

      dispatch({
        type: GET_DESCARGA_PRIVACIDAD_ERROR,
        payload: error.response.data,
      });
    } else if (error.request) {
      // client never received a response, or request never left

      dispatch({
        type: GET_DESCARGA_PRIVACIDAD_ERROR,
      });
    } else {
    }
  }
};

export const getAvisoPrivacidad = (idTipo) => async (dispatch, getState) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    return axios.post(
      `${urls.data.urlServer}${urls.data.urlAviso}`,
      {idTipo}
    );
  } catch (error) {
    console.log("Error en el aviso de privacidad");
  }
};
